<template>
  <HeadWrapper />
  <ConfigWrapperPublic>
    <div id="app_homepage_inner" class="flex flex-col w-screen h-screen">
      <HomePageNavBar class="flex-shrink-0" />
      <div class="flex flex-row flex-1 overflow-hidden">
        <HomePageSidebar />
        <div ref="scrollContainer" class="flex flex-col flex-1 rounded-tl-lg router overflow-y-auto">
        <div :class="['flex-grow flex-shrink-0 p-4', { 'min-h-full': isAppDetailPage }]">
          <router-view :key="$route.fullPath" />
        </div>
      <HomePageFooter />
        </div>

      </div>
    </div>
    <BodyWrapperPublic />
  </ConfigWrapperPublic>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { useRoute } from "vue-router";
import HomePageNavBar from "@/src/views/layout/HomePageNavBar.vue";
import HomePageSidebar from "@/src/views/layout/HomePageSidebar.vue";
import HomePageFooter from "@/src/views/layout/HomePageFooter.vue";
import HeadWrapper from "@/src/components/layout_components/HeadWrapper.vue";
import BodyWrapperPublic from "@/src/components/layout_components/public/BodyWrapperPublic.vue";
import ConfigWrapperPublic from "@/src/components/layout_components/public/ConfigWrapperPublic.vue";

const route = useRoute();
const scrollContainer = ref(null);
const isAppDetailPage = computed(() => route.name === "market-detail");

watch(() => route.fullPath, () => {
  scrollContainer.value?.scrollTo(0, 0);
});
</script>
